// @ts-ignore
import type { IClientOptions } from 'mqtt'
import { env } from '@/utils/env'

export enum MqttConnectionStatusEnum {
  OFFLINE = 'Offline',
  CONNECTING = 'Connecting',
  CONNECTED = 'Connected',
  RECONNECTING = 'Reconnecting'
}

export enum MqttLogMessageEnum {
  CONNECT_URL_NOT_CONFIGURED = '[mqtt v2] NEXT_PUBLIC_MQTT_URL is not configured',
  ATTEMPTING_CONNECT = '[mqtt v2] Attempting to connect to',
  FAILED_CONNECT_CLIENT = '[mqtt v2] Failed to connect client:',
  FAILED_DISCONNECT_CLIENT = '[mqtt v2] Failed to disconnect client:',
  FAILED_RESTORE_SUBSCRIPTIONS = '[mqtt v2] Failed to restore subscriptions:',
  FAILED_UNSUBSCRIBE_TOPIC = '[mqtt v2] Failed to unsubscribe topic:',
  CLIENT_ENDED = '[mqtt v2] Client ended by mqtt.js (for example a denied login); it is recreated on the next subscribe'
}

export enum MqttEventEnum {
  CONNECT = 'connect',
  MESSAGE = 'message',
  RECONNECT = 'reconnect',
  OFFLINE = 'offline',
  END = 'end',
  CLOSE = 'close',
  ERROR = 'error'
}

export const DEFAULT_CONNECTION_STATUS = MqttConnectionStatusEnum.OFFLINE

const DEFAULT_RECONNECT_PERIOD_MS = 5000

/** How long the socket stays open after the last subscriber leaves, so route changes do not reconnect. */
export const MQTT_IDLE_DISCONNECT_MS = 5000

const mqttKeepalive = Number(env('NEXT_PUBLIC_MQTT_KEEPALIVE') || 60)
const mqttReconnectPeriod = Number(env('NEXT_PUBLIC_MQTT_RECONNECT_PERIOD') || DEFAULT_RECONNECT_PERIOD_MS)

export const DEFAULT_OPTIONS: IClientOptions = {
  keepalive: Number.isNaN(mqttKeepalive) ? 60 : mqttKeepalive,
  reconnectPeriod: Number.isNaN(mqttReconnectPeriod) ? DEFAULT_RECONNECT_PERIOD_MS : mqttReconnectPeriod,
  username: env('NEXT_PUBLIC_MQTT_USERNAME') || 'admin',
  password: env('NEXT_PUBLIC_MQTT_PASSWORD') || 'admin'
}
